import React, { useEffect, useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  Typography,
  Container,
  CircularProgress,
  Alert,
} from "@mui/material";
import CandidateCard from "../../CandidateCard";
import { useLocation } from "react-router-dom";

// タブ定義
const TABS = [
  { label: "プロジェクト", value: "project" },
  { label: "転職先", value: "job" },
];

const CandidateListPage = () => {
  const [tab, setTab] = useState("project");
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [flashMessage, setFlashMessage] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetch("/company/candidates.json")
      .then((res) => res.json())
      .then((data) => {
        setCandidates(data.users);
        setLoading(false);
      });
  }, [location.key]);

  useEffect(() => {
    // SPA遷移時はlocation.stateで拾う
    if (location.state?.flashMessage) {
      setFlashMessage(location.state.flashMessage);
      // 履歴クリアも忘れずに
      window.history.replaceState({}, document.title, location.pathname);
      return;
    }

    // SSR/リロード時はdata属性から拾う
    const root = document.querySelector(".react-app-router");
    if (root && root.dataset.flashMessage) {
      try {
        setFlashMessage(JSON.parse(root.dataset.flashMessage));
        // data属性消しておくと安全（同じメッセージが何度も表示されるのを防ぐため）
        root.dataset.flashMessage = "";
      } catch (e) {
        setFlashMessage(root.dataset.flashMessage);
        root.dataset.flashMessage = "";
      }
    }
  }, [location.key, location.state, location.pathname]);

  // タブによる絞り込み
  const filteredCandidates = candidates.filter((c) => {
    // プロジェクト募集中か転職先募集中のいずれかがtrueの人だけ対象
    if (!c.contract_recruiting && !c.job_recruiting) return false;

    if (tab === "project") return c.contract_recruiting;
    if (tab === "job") return c.job_recruiting;
    return true;
  });

  return (
    <>
      {/* フラッシュメッセージ*/}
      {flashMessage && (
        <Box sx={{ px: 2, py: 1 }}>
          <Alert
            severity={
              typeof flashMessage === "object" ? flashMessage.type : "success"
            }
          >
            {typeof flashMessage === "object"
              ? flashMessage.message
              : flashMessage}
          </Alert>
        </Box>
      )}

      <Container maxWidth="md" sx={{ mt: 4, mb: 10 }}>
        <Typography variant="h5" fontWeight="bold" mb={2}>
          人材一覧
        </Typography>

        <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2 }}>
          {TABS.map((t) => (
            <Tab key={t.value} label={t.label} value={t.value} />
          ))}
        </Tabs>

        {loading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            <CircularProgress />
          </Box>
        ) : filteredCandidates.length === 0 ? (
          <Typography color="text.secondary" sx={{ mt: 4 }}>
            該当する人材はありません。
          </Typography>
        ) : (
          filteredCandidates.map((candidate) => (
            <CandidateCard
              key={candidate.id}
              candidate={candidate}
              tabType={tab}
            />
          ))
        )}
      </Container>
    </>
  );
};

export default CandidateListPage;
